import React from "react";

function Loading() {
    return <h2>Loading...</h2>;
}

export default Loading;